const DealerActionTypes = {
	/** ***************** ADD DEALER DETAILS START *********************** */
	ADD_DEALER_DETAILS_START: 'add_dealer_details_start',
	ADD_DEALER_DETAILS_SUCCESS: 'add_dealer_details_success',
	ADD_DEALER_DETAILS_FAILURE: 'add_dealer_details_failure',
	ADD_DEALER_DETAILS_RESPONSE_RESET: 'add_dealer_details_response_reset',
	ADD_DEALER_DETAILS_RESPONSE_CHANGED: 'add_dealer_details_response_changed',
	/** ***************** ADD DEALER DETAILS END *********************** */

	/** ***************** UPDATE DEALER DETAILS START *********************** */
	UPDATE_DEALER_DETAILS_START: 'update_dealer_details_start',
	UPDATE_DEALER_DETAILS_SUCCESS: 'update_dealer_details_success',
	UPDATE_DEALER_DETAILS_FAILURE: 'update_dealer_details_failure',
	UPDATE_DEALER_DETAILS_RESPONSE_RESET: 'update_dealer_details_response_reset',
	UPDATE_DEALER_DETAILS_RESPONSE_CHANGED: 'update_dealer_details_response_changed',
	/** ***************** UPDATE DEALER DETAILS END *********************** */

	/** ***************** GET DEALER DETAILS START *********************** */
	GET_DEALER_LIST_START: 'get_dealer_list_start',
	GET_DEALER_LIST_SUCCESS: 'get_dealer_list_success',
	GET_DEALER_LIST_FAILURE: 'get_dealer_list_failure',
	GET_DEALER_LIST_RESPONSE_RESET: 'get_dealer_list_response_reset',
	GET_DEALER_LIST_RESPONSE_CHANGED: 'get_dealer_list_response_changed',
	/** ***************** GET DEALER DETAILS END *********************** */

	/** ***************** FETCH DEALER DETAILS START *********************** */
	FETCH_DEALER_DETAILS_START: 'fetch_dealer_details_start',
	FETCH_DEALER_DETAILS_SUCCESS: 'fetch_dealer_details_success',
	FETCH_DEALER_DETAILS_FAILURE: 'fetch_dealer_details_failure',
	FETCH_DEALER_DETAILS_RESPONSE_RESET: 'fetch_dealer_details_response_reset',
	FETCH_DEALER_DETAILS_RESPONSE_CHANGED: 'fetch_dealer_details_response_changed',
	/** ***************** FETCH DEALER DETAILS START *********************** */

	/** ***************** DELETE DEALER DETAILS START *********************** */
	DELETE_DEALER_DETAILS_START: 'delete_dealer_details_start',
	DELETE_DEALER_DETAILS_SUCCESS: 'delete_dealer_details_success',
	DELETE_DEALER_DETAILS_FAILURE: 'delete_dealer_details_failure',
	DELETE_DEALER_DETAILS_RESPONSE_RESET: 'delete_dealer_details_response_reset',
	DELETE_DEALER_DETAILS_RESPONSE_CHANGED: 'delete_dealer_details_response_changed',
	/** ***************** DELETE DEALER DETAILS END *********************** */

	/** ***************** DELETE DEALER STAFF DETAILS START *********************** */
	DELETE_DEALER_STAFF_DETAILS_START: 'delete_dealer_staff_details_start',
	DELETE_DEALER_STAFF_DETAILS_SUCCESS: 'delete_dealer_staff_details_success',
	DELETE_DEALER_STAFF_DETAILS_FAILURE: 'delete_dealer_staff_details_failure',
	DELETE_DEALER_STAFF_DETAILS_RESPONSE_RESET: 'delete_dealer_staff_details_response_reset',
	DELETE_DEALER_STAFF_DETAILS_RESPONSE_CHANGED: 'delete_dealer_staff_details_response_changed',
	/** ***************** DELETE DEALER STAFF DETAILS END *********************** */

	/** ***************** APPROVE DEALER START *********************** */
	APPROVE_DEALER_START: 'approve_dealer_start',
	APPROVE_DEALER_SUCCESS: 'approve_dealer_success',
	APPROVE_DEALER_FAILURE: 'approve_dealer_failure',
	APPROVE_DEALER_RESPONSE_RESET: 'approve_dealer_response_reset',
	APPROVE_DEALER_RESPONSE_CHANGED: 'approve_dealer_response_changed',
	/** ***************** APPROVE DEALER END *********************** */
};
export default DealerActionTypes;
